import http from "./client";

export interface IBitrixStatus {
  STATUS_ID: string | number
  CATEGORY_ID: string
  ID: string | number
  NAME: string
}

export interface IBitrixCategory {
  id: string | number
  name: string
  isDefault: 'Y' | 'N'
}

export interface IBitrixDataRes {
  statuses: IBitrixStatus[]
  categories: IBitrixCategory[]
}


async function bitrixGetData(benefitId: number): Promise<IBitrixDataRes> {
  try {
    const [statusesRes, categoriesRes] = await Promise.all([
      await http.get(`/api/bitrix/statuses?id=${benefitId}`),
      await http.get(`/api/bitrix/categories?id=${benefitId}`)
    ])
    return {
      statuses: statusesRes.data?.data?.statuses,
      categories: categoriesRes.data?.data?.categories || []
    }

  } catch (e) {
    console.log(e)
    return {
      statuses: [],
      categories: []
    }
  }
}

export const bitrix = {
  bitrixGetData,
}